import {memo} from 'react'
import type {ScrollParams} from 'react-virtualized/dist/es/Grid'

import {stringifyId} from '../../../../../../../types'
import VirtualizedTree from '../../../../../../common/VirtualizedTree/VirtualizedTree'
import type {VirtualizedTreeChildProps} from '../../../../../../common/VirtualizedTree/VirtualizedTree'
import type {QueueSidebarItemType} from '../../QueueSidebar.types'

import QueueSidebarItem from './QueueSidebarItem/QueueSidebarItem'

type Props = {
  className?: string
  items: ReadonlyArray<QueueSidebarItemType>
  activeItemIndex: number
  onScroll?: (params: ScrollParams) => void
}

const renderItem = (props: VirtualizedTreeChildProps<QueueSidebarItemType>) => (
  <QueueSidebarItem key={`${props.item.type}-${stringifyId(props.item.id)}`} {...props} />
)

function QueueSidebarItems({items, className, activeItemIndex, onScroll}: Props) {
  return (
    <VirtualizedTree
      ariaLabel="Pools"
      className={className}
      flatItems={items}
      itemHeight={24}
      firstLevelIndent={8}
      levelIndent={18}
      scrollToIndex={activeItemIndex}
      onScroll={onScroll}
    >
      {renderItem}
    </VirtualizedTree>
  )
}

export default memo(QueueSidebarItems)
